const customerSchema = [
    {
      name: 'customer_name',
      label: 'Customer Name',
      type: 'text',
      required: true,
      placeholder: 'Full Name of the Customer',
      disabled: false,
    },
    {
      name: 'email',
      label: 'Email Address',
      type: 'email',
      required: false,
      placeholder: 'Email Address',
      disabled: false,
      validation: {
        pattern: {
          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          message: 'Please enter a valid email address'
        }
      }
    },
    {
      name: 'contact_number',
      label: 'Contact Number',
      type: 'text',
      required: true,
      placeholder: 'Primary Contact Number',
      disabled: false,
      validation: {
        pattern: {
          value: /^(\+\d{1,3}\s?\d{10}|\+\d{13}|\d{10})$/,
          message: 'Please enter a valid phone number (10 digits or +country code followed by 10 digits)'
        }
      }
    },
    {
      name: 'address',
      label: 'Address',
      type: 'textarea',
      required: false,
      placeholder: 'Physical Address',
      disabled: false,
    },
    {
      name: 'whatsapp_number',
      label: 'Whatsapp Number',
      type: 'text',
      required: false,
      placeholder: 'Whatsapp Number',
      disabled: false,
      validation: {
        pattern: {
          value: /^(\+\d{1,3}\s?\d{10}|\+\d{13}|\d{10})$/,
          message: 'Please enter a valid WhatsApp number (10 digits or +country code followed by 10 digits)'
        }
      }
    },
  ];
  
  export default customerSchema;
